import { CategoryFacade } from "../category/category.facade";
import { LookupType } from "./lookup-type.model";
import { LookupTypeApiFacade } from "./lookup-type.api-facade";
import { LookupTypeStoreFacade } from "./lookup-type.store-facade";

export class LookupTypeFacade extends CategoryFacade<LookupType, LookupTypeApiFacade, LookupTypeStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup-type/lookup-type.facade.ts